import { render, staticRenderFns } from "./PartialHandler.vue?vue&type=template&id=55ccd062&scoped=true"
import script from "./PartialHandler.vue?vue&type=script&lang=js"
export * from "./PartialHandler.vue?vue&type=script&lang=js"
import style0 from "./PartialHandler.vue?vue&type=style&index=0&id=55ccd062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccd062",
  null
  
)

export default component.exports